import { HttpGetOurWarehouseList } from '@/service/bespeak'

export default{
    data(){
        return {
            warehouseList: [],
        }
    },
    created() {
        HttpGetOurWarehouseList().then(res => {
            this.warehouseList = (res.data || []).map(item => {
                return {
                    value: item.id,
                    label: `${item.code}(${item.title})`,
                    code: item.code
                }
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
    },
    computed:{
        options () {
            return {
                shortcuts: [
                    {
                        text: this.$t("global.common.latest_week", {
                            defaultValue: "最近一周",
                        }),
                        value () {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            return [start, end];
                        },
                    },
                {
                    text: this.$t("global.common.recent_month", {
                        defaultValue: "最近一月",
                    }),
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(
                            start.getTime() - 3600 * 1000 * 24 * 30
                        );
                        return [start, end];
                    },
                },
                {
                    text: this.$t("global.common.latest_quarter", {
                        defaultValue: "最近一季度",
                    }),
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(
                            start.getTime() - 3600 * 1000 * 24 * 90
                        );
                        return [start, end];
                    },
                },
              ],
            };
        },
        //费用类型
        getCostType(){
            return [
                { value: 1, label: this.$t('fbb.billing.operatefeedetail', { defaultValue: '仓库作业费' }) },
				{ value: 2, label: this.$t('fbb.bill.mixin_send', { defaultValue: '配送费' }) },
				{ value: 3, label: this.$t('fbb.bill.mixin_additional', { defaultValue: '增值服务费' }) },
				{ value: 4, label: this.$t('fbb.billing.storagefeedetail', { defaultValue: '仓储费' }) },
				// { value: 5, label: this.$t('fbb.bill.mixin_material', { defaultValue: '包材费' }) },
				// { value: 6, label: this.$t('fbb.bill.mixin_adjustment', { defaultValue: '调账费' }) },
				{ value: 7, label: "库内调账"},
				{ value: 8, label: "尾程调账"},
            ]
        },
        //调账类型
        getAdjutmentType(){
            return [
                { value: 0, label: this.$t('fbb.adjustment.list_adjustdis', { defaultValue: '调账扣减' }) },
                { value: 1, label: this.$t('fbb.adjustment.list_adjustreturn', { defaultValue: '调账返还' }) },
            ]
        },
        //单据类型
        getBillType(){
            return [
                {value:0,label:this.$t('fbb.bill.mixin_income', { defaultValue: '收入' })},
                {value:1,label:this.$t('fbb.bill.mixin_pay', { defaultValue: '支出' })},
            ]
        },
        //二级分类
        getCategory() {
            return [
                {
                    label:this.$t('fbb.bill.mixin_recharge', { defaultValue: '充值' }),
                    value: '11'
                },
                // {
                //     label: '扣款',
                //     value: '12'
                // },
                // {
                //     label: '解冻',
                //     value: '13'
                // },
                {
                    label: this.$t('fbb.adjustment.list_adjustreturn', { defaultValue: '调账返还' }) ,
                    value: '14'
                },
                // {
                //     label: '冻结',
                //     value: '21'
                // },
                {
                    label: this.$t('fbb.billing.operatefeedetail', { defaultValue: '仓库作业费' }),
                    value: '22'
                },
                {
                    label: this.$t('fbb.adjustment.list_adjustdis', { defaultValue: '调账扣减' }),
                    value: '23'
                },
                {
                    label: this.$t('fbb.billing.storagefeedetail', { defaultValue: '仓储费' }),
                    value: '24'
                },
                {
                    label: this.$t('fbb.bill.mixin_additional', { defaultValue: '增值服务费' }),
                    value: '25'
                },
                {
                    label: this.$t('fbb.bill.mixin_material', { defaultValue: '包材费' }),
                    value: '26'
                },
                {
                    label: this.$t('fbb.bill.mixin_send', { defaultValue: '配送费' }),
                    value: '27'
                }
            ]
        },
    }
}
